// extracted by mini-css-extract-plugin
export const pageHeader = "editors-choice-module--pageHeader--39ubk";
export const cover = "editors-choice-module--cover--36HSI";
export const description = "editors-choice-module--description--22hwh";
export const sortOptions = "editors-choice-module--sortOptions--1vAea";
export const active = "editors-choice-module--active--1yjFs";